import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=8e7fe740&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=8e7fe740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7fe740",
  null
  
)

export default component.exports